<template>
  <td>{{ service }}</td>
</template>

<script lang="babel">
export default {
    props: ['content'],
    computed: {
      service() {
        return this.$store.getters["transaction/dictionaryEntry"](this.content);
      }
    }
};
</script>
